import { render } from "./HeaderSoc.vue?vue&type=template&id=1e806ad2&lang=pug"
const script = {}

import "./HeaderSoc.vue?vue&type=style&index=0&id=1e806ad2&lang=sass"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__